import React, { memo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const ArticlePreviewCard = memo(({ article, darkMode, onArticleClick }) => {
    // Theme-aware classes
    const textClass = 'text-sm text-muted-light dark:text-muted-dark';
    const navigate = useNavigate();

    const safeHandleClick = useCallback(() => {
            navigate(`/articles/${article.path}`);
    }, [article.path, navigate]);

    const handleClick = useCallback(() => {
        onArticleClick(article.path);
    }, [article.path, onArticleClick]);

    return (
        <div
            // Use the custom .card component and add hover effects
            className={`card h-full cursor-pointer p-3 transition-transform duration-200 hover:-translate-y-1 hover:shadow-card-hover dark:hover:shadow-2xl`}
            onClick={handleClick}
        >
            <div className="p-1">
                <h6 className="text-lg font-semibold mb-2 leading-tight text-text-light dark:text-text-dark">
                    {article.title}
                </h6>
                <p className={`${textClass} text-sm mb-3 opacity-80`}>
                    {/* Truncate long text */}
                    {article.short_text.length > 200
                        ? `${article.short_text.substring(0, 200)}...`
                        : article.short_text
                    }
                </p>
                <div className="flex justify-between items-center pt-2 border-t border-border-light dark:border-border-dark">
                    <small className={`${textClass} text-xs opacity-60`}>
                        {article.date}
                    </small>
                    
                    <button
                        onClick={e => {
                            e.stopPropagation();
                            safeHandleClick();
                        }}
                        className="text-sm font-medium text-primary dark:text-secondary hover:underline transition-colors"
                    >
                        Read Article &rarr;
                    </button>
                </div>
            </div>
        </div>
    );
});

ArticlePreviewCard.displayName = 'ArticlePreviewCard';

export default ArticlePreviewCard;